import { cn } from '@/utils';

const ChainIcon = ({
  src,
  className,
  alt,
  noBackground = false,
}: {
  src: string;
  alt?: string;
  className?: string;
  noBackground?: boolean;
}) => {
  return (
    <span
      className={cn(
        'flex size-6 items-center justify-center rounded-full p-0.5',
        {
          'bg-background': !noBackground,
        },
        className
      )}
    >
      {src ? <img src={src} alt={alt || 'Chain icon'} /> : ''}
    </span>
  );
};

export default ChainIcon;
